import { authenticationContext } from '@codametrix/ui-common';

/** Mirrors service-desk `ServiceDeskApi` — UMD host cannot import the package. */
type ServiceDeskApi = {
  apollo: any;
  getBearerToken: () => Promise<string>;
  dispose: () => void;
};

let _qaApi: ServiceDeskApi | null = null;
let _logoutRegistered = false;

const getBearerToken = async (): Promise<string> => {
  const token = authenticationContext.getToken();
  if (!token) {
    throw new Error('No authentication token available for QA Service Desk API');
  }
  if (token.indexOf('Bearer') !== -1) {
    return token;
  }
  return `Bearer ${token}`;
};

const registerLogout = () => {
  if (_logoutRegistered) return;
  globalThis.addEventListener('cmx-logout', () => {
    _qaApi?.dispose();
    _qaApi = null;
  });
  _logoutRegistered = true;
};

/**
 * QA Service Desk API (CDMX-20574) — same factory as worklist, separate Apollo cache.
 */
export const getQAServiceDeskApi = (): ServiceDeskApi => {
  registerLogout();
  if (_qaApi) return _qaApi;

  //@ts-ignore — UMD global from service-desk artifact
  _qaApi = ServiceDesk.createServiceDeskApi({
    bffURL: '/api/service-desk/bff',
    getBearerToken,
    cacheProfile: 'qa'
  });
  return _qaApi!;
};

/** @deprecated Use getQAServiceDeskApi().apollo — kept for existing call sites */
export const getQAApolloClient = () => getQAServiceDeskApi().apollo;

/** @internal tests */
export const _resetQAServiceDeskApiForTesting = () => {
  _qaApi = null;
};
